import {AddressInterface} from "@/types/Address";

export class Address implements AddressInterface {
  company: string;
  city: string;
  country: string;
  dob: Date | string;
  email: string;
  firstname: string;
  lastname: string;
  street: string;
  zip: string;

  constructor({company, city, country, dob, email, firstname, lastname, street, zip}: AddressInterface) {
    this.company = company
    this.city = city;
    this.country = country;
    this.dob = dob;
    this.email = email;
    this.firstname = firstname;
    this.lastname = lastname;
    this.street = street;
    this.zip = zip;
  }
}
